import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./third_party_order_provider.js";
//#region src/third_party_order_provider_helper.ts
var third_party_order_provider_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(provider) {
	switch (provider) {
		case "paytronix-online-ordering-webhook": return "Paytronix Online Ordering (Webhook)";
		case "verifone-commander-pos-order": return "Verifone Commander (Order Ordered at the Register)";
	}
}
//#endregion
export { name, third_party_order_provider_helper_exports };

//# sourceMappingURL=third_party_order_provider_helper.js.map